import { createPurchaseVendorForSponsorIfNotExists } from "../api/api-methods";

export const PURCHASE_VENDOR_RESOLVE_ERROR =
  "Unable to resolve vendor purchase record. Please re-select the vendor and try again.";

export const PURCHASE_VENDOR_LINK_ERROR =
  "Failed to link vendor to your organization. Please try again.";

/** Reads sponsor HC org id from Clerk JWT claims. */
export function getSponsorOrgIdFromToken(decoded) {
  const orgId = decoded?.organization_id ?? decoded?.org_id;
  return orgId == null || orgId === "" ? null : orgId;
}

/**
 * Resolves hc_purchase_vendor_id for an existing vendor under the logged-in sponsor.
 * Creates the purchaser_vendor link in Hypercomply when missing (same as New Request Vendor flow).
 */
export async function ensurePurchaseVendorForSponsor({
  providerId,
  sponsorId,
  orgId,
  existingPurchaseVendorId,
  contactEmail,
  contactName,
}) {
  if (existingPurchaseVendorId) {
    return existingPurchaseVendorId;
  }

  if (!providerId || !sponsorId || !orgId) {
    throw new Error(
      "Missing sponsor or vendor context to create purchase vendor link.",
    );
  }

  const result = await createPurchaseVendorForSponsorIfNotExists({
    sponsor_id: sponsorId,
    provider_id: providerId,
    org_id: Number(orgId),
    hc_purchase_vendor_id: 0,
    contact_email: contactEmail || "",
    contact_name: contactName || "",
  });

  return result?.hc_purchase_vendor_id ?? null;
}

/**
 * Submit-time wrapper used by Request VQQ: returns a result object instead of throwing.
 */
export async function resolveRequestVqqPurchaseVendor({
  existingPurchaseVendorId,
  providerId,
  sponsorId,
  orgId,
  contactEmail,
  contactName,
  ensurePurchaseVendor = ensurePurchaseVendorForSponsor,
}) {
  try {
    const purchaseVendorId = await ensurePurchaseVendor({
      providerId,
      sponsorId,
      orgId,
      existingPurchaseVendorId,
      contactEmail,
      contactName,
    });

    if (!purchaseVendorId) {
      return { success: false, message: PURCHASE_VENDOR_RESOLVE_ERROR };
    }

    return { success: true, purchaseVendorId };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        PURCHASE_VENDOR_LINK_ERROR,
    };
  }
}
